// Generated on 2026-10-19T22:56:31.889Z
// This file contains preloaded products top brands data from the API
// Do not edit manually - use 'npm run generate:products-top-brands-data' to regenerate

export const preloadedProductsTopBrands: any = [
  {
    "marca": "DORMAN",
    "cantidadProductosVendidos": "60743"
  },
  {
    "marca": "NAKAMOTO",
    "cantidadProductosVendidos": "45965"
  },
  {
    "marca": "GSP NORTH AMERICA",
    "cantidadProductosVendidos": "44770"
  },
  {
    "marca": "WAGNER QUICKSTOP",
    "cantidadProductosVendidos": "32447"
  },
  {
    "marca": "FEBEST",
    "cantidadProductosVendidos": "30040"
  },
  {
    "marca": "VALVOLINE",
    "cantidadProductosVendidos": "28192"
  },
  {
    "marca": "ONNURI",
    "cantidadProductosVendidos": "28118"
  },
  {
    "marca": "BANDO",
    "cantidadProductosVendidos": "26272"
  },
  {
    "marca": "DENSO",
    "cantidadProductosVendidos": "23735"
  },
  {
    "marca": "DNJ",
    "cantidadProductosVendidos": "22426"
  },
  {
    "marca": "MAHLE ORIGINAL",
    "cantidadProductosVendidos": "22306"
  },
  {
    "marca": "BECK/ARNLEY",
    "cantidadProductosVendidos": "18574"
  },
  {
    "marca": "ECOGARD",
    "cantidadProductosVendidos": "17453"
  },
  {
    "marca": "FAG",
    "cantidadProductosVendidos": "14935"
  },
  {
    "marca": "555",
    "cantidadProductosVendidos": "14768"
  },
  {
    "marca": "BLUE PRINT",
    "cantidadProductosVendidos": "14732"
  },
  {
    "marca": "PRESTONE",
    "cantidadProductosVendidos": "14690"
  },
  {
    "marca": "DAYCO",
    "cantidadProductosVendidos": "13730"
  },
  {
    "marca": "PT",
    "cantidadProductosVendidos": "12965"
  },
  {
    "marca": "TENACITY",
    "cantidadProductosVendidos": "12084"
  },
  {
    "marca": "MOTORAD",
    "cantidadProductosVendidos": "11780"
  },
  {
    "marca": "MOOG",
    "cantidadProductosVendidos": "11287"
  },
  {
    "marca": "WAGNER",
    "cantidadProductosVendidos": "10429"
  },
  {
    "marca": "HS",
    "cantidadProductosVendidos": "10241"
  },
  {
    "marca": "STANDARD/INTERMOTOR",
    "cantidadProductosVendidos": "10058"
  },
  {
    "marca": "MOOG EU",
    "cantidadProductosVendidos": "9827"
  },
  {
    "marca": "NATIONAL",
    "cantidadProductosVendidos": "9625"
  },
  {
    "marca": "WALKER",
    "cantidadProductosVendidos": "9353"
  },
  {
    "marca": "EAGLE BHP",
    "cantidadProductosVendidos": "8975"
  },
  {
    "marca": "DORMAN PREMIUM",
    "cantidadProductosVendidos": "8460"
  }
];

export default preloadedProductsTopBrands;
